import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useThemeStore = create(
  persist(
    (set, get) => ({
      // Theme can be 'light', 'dark', or 'system'
      theme: 'system',

      // Initialize theme on app load
      initTheme: () => {
        const { theme } = get();
        applyTheme(theme);
      },

      // Set theme preference
      setTheme: (newTheme) => {
        set({ theme: newTheme });
        applyTheme(newTheme);
      },

      // Toggle between light and dark
      toggleTheme: () => {
        const current = get().theme;
        const newTheme = current === 'dark' ? 'light' : 'dark';
        get().setTheme(newTheme);
      },
    }),
    {
      name: 'kwasai-theme',
    }
  )
);

// Helper function to apply theme to document
function applyTheme(theme) {
  const root = window.document.documentElement;

  // Remove existing theme classes
  root.classList.remove('light', 'dark');

  if (theme === 'system') {
    // Follow system preference
    const systemPreference = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    root.classList.add(systemPreference);
  } else {
    // Use explicit theme
    root.classList.add(theme);
  }
}

// Listen to system theme changes
if (typeof window !== 'undefined') {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    const store = useThemeStore.getState();
    if (store.theme === 'system') {
      applyTheme('system');
    }
  });
}

export { useThemeStore };
